module.exports = __webpack_public_path__ + "static/discussionapp3-9c23786d0ed9496a7a4a5223c9c99aba.png";